import React from "react";
import SiteTitleQuery from "../components/SiteTitleQuery";
import Layout from "../components/layout/Layout";
import SEO from "../components/SEO";
import Header from "../components/layout/Header";
import Title from "../components/layout/Title.js";
import CoWorkers from "../images/svgFiles/coworkersSVG.js"

function Career
() {
  return (
    <SiteTitleQuery
      render={data => (
        <Layout title={data.site.siteMetadata.title}>
          <SEO
            title="Ansökan"
            keywords={[`ansökan`, `karriär`, `projektledning`, `projektledare`, `support`, `administration`, `cad`, `cad-ingengör`, `utvecklare`, `systemutvecklare`,]}
          />
          <Header data={data} />
          <Title title="Karriär" />

          <div className="bg-WHITE-400 font-sans leading-normal tracking-normal mb-12"> 
            <div className="container w-1/2 mx-auto flex flex-col md:flex-row items-center my-8 md:my-1">
            
              <div className="w-full h-auto lg:w-2/5 lg:py-6 text-center flex flex-row justify-center items-start">
                <CoWorkers className="w-64 h-64" />
              </div>
              
              <div className="flex flex-col w-full justify-center items-start pt-12 pb-4 px-6">
                <p className="text-sm">
                Vi söker ständigt talangfulla personer med driv och engagemang.

Hos oss får Du utrymme för kreativt tänkande i en miljö där problemlösning, utveckling och samarbete är vardag.

Du kommer till en välkomnande arbetsplats med fokus på trivsel för medarbetare och respekt för kunder. Ta med dig dina erfarenheter, tankesätt och engagemang till oss och bidra till att driva PSK framåt.

                </p>
                <h1 className="font-bold text-lg my-4">
                  Välkommen in med din ansökan!
                </h1>
                <a className="leading-tight mb-4" href="mailto:rekrytering@psksyd.com">
                  rekrytering@psksyd.com
                </a>
              </div>
            </div>
          </div>
        </Layout>
      )}
    />
  );
}

export default Career
;
